import { TemplateData, TemplateParams } from '.';

const courseCompleted = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'courses',
  email: {
    buttonEnabled: true,
    buttonLink: '{{courseUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.completionCourseCompletedInfo}
        ${messages.completionEmailUserContent2}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.completionEmailUserHeading,
    subject: `{{siteName}}: ${messages.completionCourseCompleted}`
  },
  placeholders: {
    courseTitle: {
      label: messages.coursesCourseTitle,
      example: 'Test course'
    },
    courseUrl: {
      label: messages.commonCourseLink,
      example: `${serverConfig.adminUrl}/courses/test-course`
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCourseCompleted
});

export default courseCompleted;
